import { css } from 'design'
import React, { useLayoutEffect, useRef } from 'react'

export const ProgressBar = ({ mediaRef }: any) => {
  const progressRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const mediaElement = mediaRef.current
    const progressElement = progressRef.current
    if (mediaElement && progressElement) {
      const updateProgress = () => {
        progressElement.style.setProperty(
          '--progress',
          `${mediaElement.currentTime / mediaElement.duration}`,
        )
        requestAnimationFrame(updateProgress)
      }

      requestAnimationFrame(updateProgress)
    }
  }, [mediaRef])

  return (
    <div ref={progressRef} className={progressContainerStyles()}>
      <progress max="100">Progress</progress>
    </div>
  )
}

const progressContainerStyles = css({
  position: 'absolute',
  top: 0,
  left: 0,
  display: 'inline-block',
  background: 'rgba(0, 0, 0, 0.15)',
  height: '3px',
  overflow: 'hidden',
  width: '100%',

  '&:before': {
    content: '',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transform: 'scale3d(var(--progress), 1, 1)',
    transformOrigin: 'left',
    background: 'rgba(255, 255, 255, 0.75)',
  },

  progress: {
    opacity: 0,
  },
})
